<template>
  <ClientTeam />
</template>

<script>

import ClientTeam from "@/components/Account/ClientTeam.vue";

export default {
  name: 'MyTeam',
  components: {
    ClientTeam
  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>
